import React from 'react'
import './eval-data-view.styles.scss'
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const EvalDataView = () => {

  const { evalId } = useParams();
  const navigate = useNavigate();

  return (
    <div className='eval-data-container'>
      <div className='eval-data-content g-card'>
        <button 
          className='g-button small-btn' 
          onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} />
          Back
        </button>
        <div className="g-space-1"></div>
        <h3>Evaluation Data View</h3>
        <hr />
        <p>Details about the evaluation will be displayed here.</p>
      </div>
    </div>
  )
}

export default EvalDataView